import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';

import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  passwordError: String;
  public resetToken: String;
  public showErrors: boolean;
  public showSuccess: boolean = false;

  constructor(private AuthenticationService: AuthenticationService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.resetToken = params['resetToken']; //gets reset token from URL
    });
  }

  resetPassword(password: String, confirmPassword: String) {
    if(!password || !confirmPassword){
      this.passwordError = "Just enter a damn password and make sure it matches.";
    }
    else if (!this.resetToken){
      this.passwordError = "Unable to find reset token, please contact Perched Support.";
    }
    else {
      this.AuthenticationService.resetPassword(this.resetToken, password, confirmPassword).subscribe(data => {
        this.showSuccess = true;
      },
      err => {
        if(err.error[0]){
          this.passwordError = err.error[0].msg;
        }
        else {
          this.passwordError = err.error.msg;
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/login/reset-password/reset-password.component.ts